import React, { useState } from 'react';

const ImportProductForm = ({ onImportComplete }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) return alert('Please select a file');

    const formData = new FormData();
    formData.append('file', file);

    try {
      setLoading(true);

      const res = await fetch('/api/products/import', {
        method: 'POST',
        body: formData
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.error);

      alert(`✅ Success: ${data.success}\n❌ Failed: ${data.failed}`);

      console.log(data.results);

      onImportComplete && onImportComplete();

    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h3>Import Products</h3>

      <form onSubmit={handleSubmit}>
        <input
          type="file"
          accept=".xlsx"
          onChange={(e) => setFile(e.target.files[0])}
        />

        <button type="submit" disabled={loading}>
          {loading ? 'Importing...' : 'Upload & Import'}
        </button>
      </form>
    </div>
  );
};

export default ImportProductForm;